import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconHorizonFolderOrangeSizeS from './IconHorizonFolderOrange_size_s';

const props: CreateIconArguments = {
  l: IconHorizonFolderOrangeSizeS,
  m: IconHorizonFolderOrangeSizeS,
  s: IconHorizonFolderOrangeSizeS,
  xs: IconHorizonFolderOrangeSizeS,
  name: 'IconHorizonFolderOrange',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
